<template lang="pug">
  v-card
    v-card-title
      h2.modal-title Редагувати модель
    v-card-content
      v-text-field(
        label="Назва моделі"
        v-model="form.name"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
      )
    v-card-actions
      v-btn(
        :disabled="!form.name"
        @click="onSave"
        :loading="loading"
      ) {{ 'base.save' | translate }}
      delete-btn(
        @delete="onDelete"
      )
</template>

<script>
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
export default {
  name: 'EditModelModal',
  components: { DeleteBtn },

  props: {
    selected: {
      type: Object,
      default: () => ({})
    }
  },
  mixins: [formErrorsMixin],
  data: () => ({
    form: {},
    errors: {
      name: null
    },
    loading: false
  }),

  mounted () {
    this.form = { ...this.selected }
  },

  methods: {
    async onSave () {
      this.loading = true
      this.checkValidData()

      if (this.errors.name === null) {
        const updatedData = { ...this.form }

        this.$emit('update', updatedData)
        this.$emit('close')
      }

      this.loading = false
    },
    checkValidData () {
      this.errors.name = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    },
    async onDelete () {
      this.$emit('delete', this.form.id)
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
  display: flex;
  gap: 1rem;
}

.v-card__actions button:first-child {
  flex: 1;
}
</style>
